export const contentThemes = {
    shayari: {
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        icon: '📜',
        color: '#667eea',
        bgColor: '#f0e7ff'
    },
    joke: {
        gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        icon: '😂',
        color: '#f5576c',
        bgColor: '#fff0f3'
    },
    quote: {
        gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        icon: '💭',
        color: '#4facfe',
        bgColor: '#e6f7ff'
    },
    story: {
        gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
        icon: '📖',
        color: '#43e97b',
        bgColor: '#e6fff5'
    },
    riddle: {
        gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
        icon: '🤔',
        color: '#fa709a',
        bgColor: '#fff8e6'
    },
    'pickup-line': {
        gradient: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
        icon: '💘',
        color: '#ff9a9e',
        bgColor: '#fff0f5'
    },
    roast: {
        gradient: 'linear-gradient(135deg, #ff6b6b 0%, #feca57 100%)',
        icon: '🔥',
        color: '#ff6b6b',
        bgColor: '#fff3e6'
    },
    compliment: {
        gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
        icon: '🌟',
        color: '#fcb69f',
        bgColor: '#fff5f0'
    },
    'dad-joke': {
        gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
        icon: '👨',
        color: '#a8edea',
        bgColor: '#f0ffff'
    },
    haiku: {
        gradient: 'linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)',
        icon: '🎋',
        color: '#d299c2',
        bgColor: '#fef9f5'
    },
    'rap-lyrics': {
        gradient: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)',
        icon: '🎤',
        color: '#3498db',
        bgColor: '#e8f4f8'
    },
    'tweet-thread': {
        gradient: 'linear-gradient(135deg, #1da1f2 0%, #5cb3ff 100%)',
        icon: '🐦',
        color: '#1da1f2',
        bgColor: '#e6f3ff'
    },
    acrostic: {
        gradient: 'linear-gradient(135deg, #90b4ce 0%, #5a3a7e 100%)',
        icon: '✍️',
        color: '#5a3a7e',
        bgColor: '#f5f0ff'
    },
    'motivational-speech': {
        gradient: 'linear-gradient(135deg, #f77062 0%, #fe5196 100%)',
        icon: '💪',
        color: '#fe5196',
        bgColor: '#fff0f7'
    }
};

export const toneEmojis = {
    funny: '😄',
    serious: '🧐',
    romantic: '💖',
    motivational: '🚀'
};

export const lengthLabels = {
    short: 'Short',
    medium: 'Medium',
    long: 'Long'
};
